import { Col, Row } from "@payping/web-components";
import { FC, ReactNode } from "react";

interface Props {
  title?: ReactNode;
  firstChild?: ReactNode;
  secondChild?: ReactNode;
}

export const CustomFormLayout: FC<Props> = (props) => {
  const { title, firstChild, secondChild } = props;
  return (
    <Row
      justify={"start"}
      gutter={[16, 32]} // this margin is for chat at the bottom of the screen, which is 54 + 14 in small size & 60 + 40 + 20 in larger sizes
    >
      <Col xs={24} lg={24}>
        {title}
      </Col>
      <Col xs={24} lg={12}>
        {firstChild}
      </Col>
      <Col xs={24} lg={12}>
        {secondChild}
      </Col>
    </Row>
  );
};
